
class CapSubmitStudentNotification {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'submit_student_notification'
}

function create(config) {
  return new CapSubmitStudentNotification(config)
}

export default {
  key,
  create,
}
